import React from "react"
import "./frames.css"
const GestionAduanas = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">Gestión de Aduanas</h1>

      <h2 className="frames-subtitle">Nuestro Enfoque</h2>
      <p className="frames-text">
        Entendemos que las gestiones aduaneras pueden ser un punto crítico en la
        cadena de suministro de equipos médicos. Nuestro equipo de expertos
        tiene amplia experiencia en el manejo de documentación, pagos de
        impuestos y otras formalidades necesarias para que su equipo pase sin
        problemas por la aduana.
      </p>

      <h2 className="frames-subtitle">Documentación y Trámites</h2>
      <ul className="frames-text">
        <li>
          Preparación de Documentos: Nos encargamos de la preparación y
          presentación de todos los documentos necesarios para el despacho
          aduanero.
        </li>
        <li>
          Pago de Impuestos y Tarifas: Gestionamos el pago de todos los
          impuestos y tarifas aplicables.
        </li>
      </ul>

      <h2 className="frames-subtitle">Coordinación y Seguimiento</h2>
      <p className="frames-text">
        Liaison con Autoridades Aduaneras: Mantenemos una comunicación constante
        con las autoridades aduaneras para asegurar que todo el proceso se
        realice de manera eficiente y sin contratiempos.
      </p>

      <h2 className="frames-subtitle">Objetivo Final</h2>
      <p className="frames-text">
        El objetivo es garantizar un proceso de importación y exportación
        fluido, evitando cualquier posible inconveniente que pueda surgir
        durante las gestiones aduaneras. Este enfoque proactivo no sólo ahorra
        tiempo, sino que también evita costos adicionales y posibles sanciones.
      </p>
    </div>
  )
}

export default GestionAduanas
